import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'
import { Membership } from 'se-resource-types/dist/lib/MembershipService'
import { ApiService } from './api.service'
import { Store } from './store'

@Injectable({
  providedIn: 'root'
})
export class MembershipService extends Store<Membership[]> {

  constructor(private api: ApiService) {
    super([])
  }

  public mine(params={}): Observable<Membership[]> {
    return this.api.get('memberships/mine', { params }).pipe(
      first(),
      map(data => data.result)
    )
  }

  public childlessOrMissingChild(membership: Membership, memberships: Membership[]): boolean {
    // True if this membership if it has no linked children
    if (!membership.membership_definition.child_membership_definition_links.length) return true

    let foundChildren = 0

    const memDefCount = new Map<string, number>()
    for(const mem of memberships) {
      const memDefId = mem.membership_definition.id
      if (memDefCount.has(memDefId)) {
        memDefCount.set(memDefId, memDefCount.get(memDefId) + 1)
      }
      else {
        memDefCount.set(memDefId, 1)
      }
    }

    // Sum up all of the child memberships
    for(const childMemDef of membership.membership_definition.child_membership_definition_links) {
      if (memDefCount.has(childMemDef.child_membership_definition_id)) {
        foundChildren += memDefCount.get(childMemDef.child_membership_definition_id)
      }
    }

    // True if there are more parents than children
    return memDefCount.get(membership.membership_definition.id) > foundChildren
  }

}
